
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

!firebase.apps.length
  ? firebase.initializeApp({
    apiKey: "AIzaSyAWdF7Ga0zEfvn8wr3aUOiNnwnCeNubaRw",
    authDomain: "maneearabica.firebaseapp.com",
    projectId: "maneearabica",
    storageBucket: "maneearabica.firebasestorage.app",
    messagingSenderId: "903644982216",
    appId: "1:903644982216:web:91deb3b34b06535be76efd",
    measurementId: "G-186QHFSFQT"
  })
  : firebase.app();

const database = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export { firebase, database, auth, storage };


